import gql from "graphql-tag";

export const PRODUCTS_QUERY = gql`
  query {
    products(first: 250) {
      edges {
        cursor
        node {
          id
          title
          description
          handle
          vendor
          tags
          variants(first: 100) {
            edges {
              node {
                id
                title
                image {
                  src
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const PRODUCTS_QUERY_LIMIT = gql`
  query ($after: String!)  {
    products(first: 250,after: $after) {
      edges {
        cursor
        node {
          id
          title
          description
          handle
          vendor
          tags
          variants(first: 100) {
            edges {
              node {
                id
                title
                image {
                  src
                }
              }
            }
          }
        }
      }
    }
  }
`;
